import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'
import { CompanySelectors } from '../../store/company/selectors'
import { SessionSelectors } from '../../store/session/selectors'
import { FlexColumn, FlexRow } from '../../components/atoms/layout/Flex'
import Label from '../../components/atoms/display/Label'
import usePage from '../../hooks/usePage'
import Button from '../../components/atoms/inputs/Button'
import Container from '../../components/atoms/layout/Container'
import { AttachmentIcon, DeleteIcon } from '../../components/atoms/display/Icons'
import { CompanyActions } from '../../store/company'
import FileSelectButton from '../../components/atoms/inputs/FileSelectButton'
import Checkbox from '../../components/atoms/inputs/Checkbox'
import IconButton from '../../components/atoms/inputs/IconButton'

export default function CompanyRepresentativePage() {
  const { changeTitle } = usePage()
  const company = useSelector(CompanySelectors.company)
  const user = useSelector(SessionSelectors.user)
  const [agreement, setAgreement] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const [selectedFileError, setSelectedFileError] = useState<string | null>(null)
  const dispatch = useDispatch()

  useEffect(() => {
    changeTitle('企業情報', '代表者承認')
  }, [changeTitle, company])

  const handleSelect = useCallback(
    (files: File[]) => {
      setSelectedFileError(null)
      if (selectedFiles.length + files.length > 2) {
        setSelectedFileError('本人確認書類は３件以上アップロードできません')
        return
      }
      setSelectedFiles([...selectedFiles, ...files])
    },
    [selectedFiles]
  )

  const handleDelete = useCallback(
    (file: File) => {
      setSelectedFiles(selectedFiles.filter((f) => f !== file))
    },
    [selectedFiles]
  )

  const handleSubmit = useCallback(() => {
    if (selectedFiles.length > 0) {
      dispatch(CompanyActions.uploadRepresentativeCertification({ files: selectedFiles, redirectToCompleted: true }))
    }
  }, [dispatch, selectedFiles])

  if (
    user === undefined ||
    company?.representative?.userId !== user.id ||
    company.representative.submittedAt !== null
  ) {
    return <></>
  }

  return (
    <Container>
      <FlexColumn>
        <Label text="運転免許証等の本人確認書類（表面・裏面）を、JPEGまたはPNG、PDFファイルでアップロードをしてください。" />
        <FlexRow align="center">
          <FileSelectButton accepts={['application/pdf', 'image/jpeg', 'image/png']} multiple onSelect={handleSelect}>
            本人確認書類の選択
          </FileSelectButton>
          <FlexColumn align="flex-start">
            {selectedFiles.map((file) => (
              <FlexRow justify="center" align="center">
                <AttachmentIcon />
                <Label text={file.name} />
                <IconButton label="削除" onClick={() => handleDelete(file)}>
                  <DeleteIcon />
                </IconButton>
              </FlexRow>
            ))}
            {selectedFiles.length === 0 && <Label text="本人確認に必要な書類を選択してください" />}
          </FlexColumn>
        </FlexRow>
        {selectedFileError && <Label text={selectedFileError} color="error" />}
        <Checkbox label="取引先とmonectで電子契約することに同意する" checked={agreement} onChange={setAgreement} />
        <FlexColumn space={0}>
          <Label
            text="※ 本人確認書類をアップロードしたうえで、内容に誤りがないことを必ずご確認の上、承認してください。"
            variant="caption"
          />
          <Label text="承認後は修正できません。" variant="caption" />
        </FlexColumn>
        <FlexColumn>
          <FlexRow justify="center">
            <Button disabled={selectedFiles.length === 0 || !agreement} onClick={handleSubmit}>
              承認する
            </Button>
          </FlexRow>
        </FlexColumn>
      </FlexColumn>
    </Container>
  )
}
